import { FC } from 'react';
import { Typography, ArrowLeft } from '@dreamteam-monorepo/ui';

export const BackButton: FC<{ onClick: () => void }> = ({ onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className="flex items-center gap-1 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 rounded-[--corner-xs]"
  >
    <ArrowLeft className="size-5 text-[--color-blue-200]" />
    <Typography as="span" variant="button020" className="text-[--color-blue-200] text-[16px]">
      Back
    </Typography>
  </button>
);
